import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "modal__header" }, "Disable Slack integration", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "modal__text" }, " Disabling Slack integration will stop the functionality of any Slack related features, such as check-in outreach. Are you sure you want to disable Slack integration? ", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Disable")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_test = _resolveDirective("test")!

  return (_openBlock(), _createBlock(_component_Modal, {
    id: "disable-slack-modal",
    theme: "disable-slack"
  }, {
    actions: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
        theme: "secondary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('slack:cancel')))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })), [
        [_directive_test, 'button-cancel']
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
        theme: "danger",
        loading: _ctx.loading,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('slack:disconnect')))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["loading"])), [
        [_directive_test, 'button-disable']
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}